var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authentication"},[(_vm.stage === 1)?_c('input-page',{on:{"next":_vm.next}}):_vm._e(),(_vm.stage === 2)?_c('photo-page',{on:{"submit":_vm.submit}}):_vm._e(),_c('auth-dialog',{attrs:{"show":_vm.showDialog,"success":_vm.submitSuccess},on:{"confirm":_vm.goBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }